import { contactSearch } from './contact-search';
import { encoders } from './encoders';
import { hardwareCycles } from './hardware-cycles';
import { hardwareLocations } from './hardware-locations';
import { hardwareModels } from './hardware-models';
import { hardwareStatuses } from './hardware-statuses';
import { hardwareUnits } from './hardware-units';
import { users } from './users';

export const v1 = {
  contactSearch,
  encoders,
  hardwareCycles,
  hardwareLocations,
  hardwareModels,
  hardwareStatuses,
  hardwareUnits,
  users,
};
